import { Box, Flex, Heading, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import 'borrower/borrower.scss';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { CreditFacilitySelect } from 'packages/credit-facility/ui/CreditFacilitySelect';
import { ExpensesFeesViewContainer } from 'packages/statements/ui/ExpensesFeesViewContainer';
import { StatementsTemplate } from 'packages/statements/ui/StatementsTemplate';

export const StatementsExpensesFeesRoute = () => {
  const toast = useToast();
  const navigate = useNavigate();

  let routeLevelError = false;

  return (
    <Box className="main">
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load expenses and fees landing route`;
            routeLevelError = true;
            toast(errorToastConfig);
            navigate('/');
          }
        }}
      >
        <Flex justify="space-between">
          <Heading as="h2">Statements</Heading>
          <Box>
            <CreditFacilitySelect />
          </Box>
        </Flex>
        <StatementsTemplate>
          <ExpensesFeesViewContainer />
        </StatementsTemplate>
      </Sentry.ErrorBoundary>
    </Box>
  );
};
